import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { IUser } from "../../common/types/userTypes";

const initialState: IUser = {
  _id: '',
  email: '',
  phone: '',
  organisationId: '',
  groupId: '',
  roleName: '',
  dataFetched:false,
  isPasswordEnable: false,
  status: '',
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    _updateUser: (state, action) => {
      state.email = action.payload['email'];
      state.roleName = action.payload['roleName'];
      state.organisationId = action.payload['organisationId']
        ? action.payload['organisationId']
        : '';
      state.groupId = action.payload['groupId']
        ? action.payload['groupId']
        : '';
      state.name = action.payload['name'] ? action.payload['name'] : '';
      state.isPasswordEnable = String(action.payload['isPasswordEnable']) === 'true';
      state.dataFetched = true;
    },
  },
});

export const selector = (state: RootState) => state.users;

export const { _updateUser } = userSlice.actions;
export default userSlice.reducer;
